import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  cssDialogTitle: {
    '& .MuiTypography-h6': {
      fontWeight: 500,
      fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
      fontSize: '1.5rem',
      textAlign: 'center',
      color: theme.palette.grey[600],
    },
  },
}));

export default useStyles;
